import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAdminAuth } from '../utils/auth';

/**
 * Protects /profile/business. Only allows access when:
 * - User is logged in
 * - User is a business user (role vendor/venue/business or has business_id)
 * Blocks direct URL access: redirects to /login?type=business if not logged in, to / if not business.
 */
function BusinessCompletionRoute({ children }) {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.utilityReducer?.isLoggedIn);
  const userData = useSelector((state) => state.utilityReducer?.userData);
  const loginData = useSelector((state) => state.loginReducer?.loginData);

  const role = userData?.role ?? userData?.user_type ?? userData?.userType ?? '';
  const hasBusinessId = loginData?.business_id != null;
  const isBusinessUser =
    role === 'vendor' || role === 'venue' || role === 'business' || hasBusinessId;

  useEffect(() => {
    if (getAdminAuth()) {
      navigate('/admin/dashboard', { replace: true });
    return;
    }
    if (!isLoggedIn) {
      navigate('/login?type=business', { replace: true });
      return;
    }
    if (!isBusinessUser) {
      navigate('/', { replace: true });
    }
  }, [isLoggedIn, isBusinessUser, navigate]);

  if (getAdminAuth() || !isLoggedIn || !isBusinessUser) {
    return null;
  }

  return children;
}

export default BusinessCompletionRoute;
